var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutQrWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6281 30.2134C25.5574 28.7067 30.0441 23.5854 30.6068 17.3334H23.9654C23.7174 22.0627 22.1574 26.4627 19.6281 30.2134ZM30.6068 14.6667C30.0441 8.41335 25.5534 3.29069 19.6228 1.78402C22.1534 5.53602 23.7161 9.93602 23.9654 14.6667H30.6068ZM12.3788 1.78402C6.44542 3.29069 1.95742 8.41335 1.39209 14.6667H8.03476C8.28409 9.93602 9.84676 5.53602 12.3788 1.78402ZM1.39342 17.3334C1.67034 20.3508 2.87422 23.2086 4.83986 25.5147C6.8055 27.8207 9.43659 29.462 12.3721 30.2134C9.84276 26.4627 8.28276 22.0627 8.03476 17.3334H1.39342ZM16.0001 30.616C12.9241 26.9027 10.9974 22.3214 10.7068 17.3334H21.2948C21.0014 22.32 19.0761 26.9027 16.0014 30.616M16.0001 1.39069C19.0761 5.10269 21.0001 9.68269 21.2934 14.6667H10.7068C11.0001 9.68269 12.9254 5.10269 16.0001 1.39069Z",
    fill: "#3B9FBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutQrWeb);
export default __webpack_public_path__ + "static/media/aboutQrWeb.e27b4e2d525031fa63a8fb3a51d33f03.svg";
export { ForwardRef as ReactComponent };